import { RouteObject } from "react-router-dom";
import AddSchedule from "./components/create/components/create";
import ScheduleDetail from "./components/details/ScheduleDetails";
import Schedules from "./components/landing/schedule";

export interface scheduleRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: scheduleRoute[];
}
export const scheduleRoutes: scheduleRoute[] = [
  {
    path: "/ax/service-order/schedule",
    element: <Schedules />,
  },
  {
    path: "/ax/service-order/schedule/create",
    element: <AddSchedule />,
  },
  {
    path: "/ax/service-order/schedule/:action/:id",
    element: <AddSchedule />,
  },
  {
    path: "/ax/service-order/schedule/view/:id",
    element: <ScheduleDetail />,
  },
];
